var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.$style.wrapper},[_c('input',_vm._g(_vm._b({attrs:{"type":"radio"},domProps:{"checked":_vm.isChecked,"value":_vm.value}},'input',_vm.$attrs,false),_vm.eventListeners)),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }